import { IconButton, SxProps, Tooltip } from '@mui/material'
import TuneIcon from '@mui/icons-material/Tune'

interface FilterButtonProps {
  dataTestId?: string
  title?: string
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void | (() => void)
  sx?: SxProps
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start'
    | undefined
  color?:
    | 'action'
    | 'disabled'
    | 'primary'
    | 'inherit'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
}

function FilterButton({
  title = 'Filters',
  onClick,
  sx,
  placement = 'bottom',
  color = 'primary',
  dataTestId,
}: FilterButtonProps) {
  return (
    <Tooltip title={title} placement={placement}>
      <IconButton onClick={onClick}>
        <TuneIcon sx={sx} color={color} data-testid={dataTestId} />
      </IconButton>
    </Tooltip>
  )
}

export default FilterButton
